import React from "react";

import {
    Route
} from "react-router-dom";

export class GoBack extends React.Component {
    constructor(props) {
        super(props);

        this.click = this.click.bind(this);
    }

    click(route) {
        // dok pokreneš browser već ima 1, onda mcasino 2, pak za back mora biti više od 2, nekužim do kraja
        if (route.history.length > 2 && !this.props.disableBrowserBack)
            route.history.goBack();
        else
            route.history.push(this.props.toUrl);
    }

    render() {
        return <Route render={(route) =>
            <div className={this.props.className} onClick={() => this.click(route)}>
                {this.props.children}
            </div>
        } />
    }
}
